import { useState } from 'react';
import { useNavigate } from 'react-router-dom'
import { compressImage, blobToBase64 } from '../utils/imageUtils';
import axios from 'axios'
import config from '../config';

export const FormHandler = (initialState, id, endpoint) => {
    const [formData, setFormData] = useState(initialState);
    const [locations, setLocations] = useState([])
    let navigate = useNavigate()

    const handleChange = async (e) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value
        let name = e.target.name
        if (e.target.type === "file"){
            const file = e.target.files[0]
            name = await compressImage(file)
        }
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }))


    }
    const handleFileChange = async (e) => {
        e.preventDefault();
        console.log("start file change")
        const file = e.target.files[0];
        if (!file) return;
        console.log("compress file")

        const blob = await compressImage(file);
        const base64String = await blobToBase64(blob);
        setFormData(prev => ({
            ...prev,
            pic:  base64String
        }));
    };

    const checkPLZ = (event) => {
        /*for testing purposes
        return true;
        */
        if  (locations.includes(formData.plz) || formData.plz ===""){
          return true;
        }
        else{
          return false;
      }
  
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        const file = formData.pic;
        const isValid = checkPLZ();
        if (endpoint === "item" && !file){
            return false
        }
        if (isValid){
            await sendData(formData);
        }


    }    

    const sendData = async (e) => {
        console.log("sendData")
        try {
            const response = await axios.put(`${config.apiUrl}${endpoint}`,
                                        {
                                            data: formData,
                                            id: id
                                        },
                                        {
                                            headers: {"token": localStorage.getItem("token")}
                                        }
            )      
            
            const success = response.status === 200
            if (success) {
                navigate('/dashboard')
                }
            } catch (err) {
                console.log(err)
            }

    }
    const getLocations = async () => {

        try{
            const response = await axios.get(`${config.apiUrl}locations`)
            setLocations(response.data)
        }
        catch (error){
            console.log(error)
        }
    }
    return { formData, setFormData, handleChange, handleFileChange, handleSubmit, getLocations };
};
export default FormHandler